const e = (t) => {
  if (t) return t ? "true" : "false";
};
export {
  e as setAriaInvalid
};
